import * as React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import Dropdown, { DropDownPosition } from 'components/DropDownMenu/DropDownMenu';
import Button from 'components/Button';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import defaultStyles from './Menu.css';
import { handleLoginAction } from 'utils/LoginUtils/smartLoginHelper';
import { makeLoginRequest } from 'actions/LoginSignupActions/loginActions';
import { showModal } from 'actions/modalActions';
import { withToast } from 'components/Toast/Toast';
import { Link } from 'react-router';
import { withRouter } from 'react-router';
import omnitureHelper from 'utils/omnitureHelper';
import { LOGIN_SOURCE_HEADER } from 'constants/LoginConstants';
import { LoginViews } from 'components/LoginSignupWidget/LoginTypes';
import { DROP_MENU_MAX_WIDTH, LOGOUT_MENU_LINKS } from './MenuComponentConstants';
class SignupLoginMenu extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = (view) => {
            return (e) => {
                const { isLoginPage, showModal, makeLoginRequest, toast, omniturePageType } = this.props;
                let omnitureData = {};
                switch (view) {
                    case LoginViews.LOGIN:
                        omnitureData = {
                            source: 'LoginClick',
                            omniturePageType,
                            loginSource: LOGIN_SOURCE_HEADER
                        };
                        break;
                    case LoginViews.SIGNUP:
                        omnitureData = {
                            view: 'SignUp',
                            source: 'SignUpClick',
                            omniturePageType,
                            loginSource: LOGIN_SOURCE_HEADER
                        };
                        break;
                    default:
                        break;
                }
                if (!isLoginPage) {
                    if (view === LoginViews.LOGIN) {
                        const loginPayload = {
                            showModal,
                            toast,
                            makeLoginRequest,
                            omnitureData,
                            view
                        };
                        handleLoginAction(loginPayload);
                    }
                    else {
                        this.props.showModal(view, { pageType: omniturePageType, loginSource: LOGIN_SOURCE_HEADER });
                    }
                    e && e.preventDefault();
                }
            };
        };
        this.handleLoginDropDown = (show) => () => {
            this.setState({
                showLoginDropDown: show,
                showInitialLoginDropDown: false
            });
        };
        this.handleTrackClick = (item) => () => {
            if (!item) {
                return;
            }
            // Sets the omniConext with Login page Type and Account Item Name (Ex: My_Profile)
            // This gets retrieved in login page for tracking any login flow in that page.
            omnitureHelper.setPageContext('Login', {
                pageType: item
            });
        };
        this.renderDropDownContent = () => {
            return (<div className={defaultStyles['login-dropdown']}>
				{!this.state.showLoginDropDown && (<Button secondary className={defaultStyles['button']} onClick={this.handleClick('login')}>
						{stringTemplate('loginHeaderText')}
					</Button>)}
				<div className={defaultStyles['signup-container']}>
					<div> {stringTemplate('loginHeaderNewCustomer')}</div>
					<div className={defaultStyles['signup']} onClick={this.handleClick('signup')}>
						{stringTemplate('loginHeaderSignUp')}
					</div>
				</div>
			</div>);
        };
        this.renderDropDownExtension = () => {
            const logoutLinks = LOGOUT_MENU_LINKS.map((item, i) => {
                return (<li key={`acclinks-${i}`} className={defaultStyles['links-item']}>
					<Link to={item.href} className={cx(defaultStyles['link'], defaultStyles['account-link'])} onClick={this.handleTrackClick(item.pageType)}>
						{item.icon && <item.icon width={item.width} height={item.height}/>}
						<div className={defaultStyles['item-link']} data-aid={item['dataAid']}>
							{item.text}
						</div>
					</Link>
				</li>);
            });
            return <ul className={cx(defaultStyles['links'], defaultStyles['account-border'])}>{logoutLinks}</ul>;
        };
        this.state = {
            showLoginDropDown: false,
            showInitialLoginDropDown: false
        };
    }
    componentDidMount() {
        const { isLoginPage } = this.props;
        // Shows Login dropdown with login button for 1 second and hides it afterwards.
        if (!isLoginPage) {
            this.setState({
                showInitialLoginDropDown: true
            });
            this.timerId = setTimeout(this.handleLoginDropDown(false), 1000);
        }
    }
    componentWillUnmount() {
        const { isLoginPage } = this.props;
        // Clears timeout which was created in didmount.
        if (!isLoginPage) {
            clearTimeout(this.timerId);
        }
    }
    render() {
        const { coBrandStyles, location, isGrocery } = this.props;
        const { showLoginDropDown, showInitialLoginDropDown } = this.state;
        const styles = Object.assign({}, defaultStyles, coBrandStyles);
        const loginUrl = `/account/login?ret=${location.pathname}${encodeURIComponent(location.search || '')}`;
        const loginTitle = (<Link to={loginUrl} data-aid="Login" className={cx(styles['login-white-button'], { [styles['grocery-login']]: isGrocery })} onClick={this.handleClick('login')}>
				{stringTemplate('loginTitleTxt')}
			</Link>);
        return (<div className={styles['item-container']} onMouseEnter={this.handleLoginDropDown(true)} onClick={this.handleLoginDropDown(!this.state.showLoginDropDown)} onMouseLeave={this.handleLoginDropDown(false)}>
				<Dropdown position={DropDownPosition.CENTER} contentMaxWidth={DROP_MENU_MAX_WIDTH} content={loginTitle} active={showLoginDropDown || showInitialLoginDropDown} fixPosition className={styles['drop-menu']} tooltipClassName={styles['dropdown-container']} containerClassName={styles['dropdown-inner-container']}>
					{this.renderDropDownContent()}
					{showLoginDropDown && this.renderDropDownExtension()}
				</Dropdown>
			</div>);
    }
}
const mapDispatchProps = {
    showModal,
    makeLoginRequest
};
export default withRouter(connect(null, mapDispatchProps)(withToast(SignupLoginMenu)));
